import React, { MutableRefObject, useImperativeHandle, useMemo, useState } from 'react';
import { NewAuthDialogContext, NewAuthDialogState } from './NewAuthDialogContext';

interface NewAuthDialogProviderProps {
    children: any;
    apiRef?: MutableRefObject<NewAuthDialogState>;
    onEnd?: () => void;
    fromCartCheckout?: boolean;
    cartItems?: any;
    totalAmount?: any;
}

export function NewAuthDialogProvider({
    onEnd: defaultOnEnd,
    children,
    apiRef,
    fromCartCheckout,
    cartItems,
    totalAmount,
}: NewAuthDialogProviderProps) {
    const [open, setOpen] = useState(false);
    const [onEnd, setOnEnd] = useState(() => defaultOnEnd ?? null);

    const state = useMemo<NewAuthDialogState>(
        () => ({
            open,
            setOpen,
            onEnd,
            setOnEnd,
            fromCartCheckout,
            cartItems,
            totalAmount,
        }),
        [open, setOpen, onEnd, setOnEnd],
    );

    useImperativeHandle(apiRef, () => state, [state]);

    return <NewAuthDialogContext.Provider value={state}>{children}</NewAuthDialogContext.Provider>;
}

export default NewAuthDialogProvider;
